import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    //marginTop: theme.spacing(10),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    marginTop: theme.spacing(0.5),
    fontSize: 20,
    color: 'black',
  },
  buttonBox: {
    marginTop: theme.spacing(3),
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 15,
    width: '30%',
  },
  greyBtn: {
    width: '30%',
    marginRight: theme.spacing(1),
    boxShadow: 'none',
    textTransform: 'none',
  },
  actionBtn: {
    width: '60%',
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `0 ${theme.spacing(3)}px`,
  },
  text: {
    //margin: '0 0 24px',
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(0.5),
    fontSize: 15,
    color: 'black',
  },
}));
